import React, { Component } from "react";
import {  Typography } from "@material-ui/core";
import { PURPLE_COLOR, GREEN } from "../constants";
export default class Labelcontrol extends Component {
  render() {
    var primaryColor = "black";
    var secondaryColor = PURPLE_COLOR;
    return (
      <Typography
        style={{ padding: 10, color: secondaryColor,fontWeight:'500' }}
      >
        <span style={{ color: primaryColor }}>{this.props.title} </span>
        {this.props.content}
      </Typography>
    );
}}
